// Keys under which the app parks state in the browser. Named here rather than
// spelled out at each use so the e2e suite can seed and clear the same values
// the app reads — a renamed literal would otherwise break silently, with the
// test still green and the dialog back in the way.
export const StorageKeys = {
  // sessionStorage: the app hint was shown in this browser session.
  APP_PROMO_SEEN: 'cc-app-promo-seen',
} as const;
